<template>
	<div class="brand-logo-grid">
		<!-- <h2>SHOP BY BRAND</h2> -->
        <div class="list">
        	<div v-for="brand in brands" :key="brand.brand">
	            <router-link :to="{ name: 'BrandWithTag', params: { brand: (( brand.tag.length > 0 ) ? brand.tag : brand.brand), tag: tag } }">
	                <img :src="['images/brands/', brand.img].join('')" :alt="brand.brand">
	            </router-link>
        	</div>
        </div>
    </div>
</template>

<script>
export default {
	name: "BrandLogoGrid",
	computed: {},
	props: ['tag', 'include'],
	data: function() {
		return {
			availableBrands: [
				{ brand: 'aimpoint', img: 'aimpoint.png', tag: 'aimpoint' },
				{ brand: 'arsenal', img: 'arsenal.png', tag: 'arsenal' },
				{ brand: 'barrett', img: 'barrett.jpg', tag: 'barrett' },
				{ brand: 'benchmade', img: 'benchmade.png', tag: 'benchmade' },
				{ brand: 'benelli', img: 'benelli.png', tag: 'benelli' },
				{ brand: 'beretta', img: 'beretta.jpg', tag: 'beretta' },
				{ brand: 'boker', img: 'boker.jpg', tag: 'boker' },
				{ brand: 'bcm', img: 'bravo-company-mfg.png', tag: '' },
				{ brand: 'browning', img: 'browning.jpg', tag: '' },
				{ brand: 'burris-optics', img: 'burris-optics.png', tag: '' },
				{ brand: 'bushnell', img: 'bushnell.png', tag: '' },
				{ brand: 'century-arms', img: 'century-arms.jpg', tag: '' },
				{ brand: 'colt', img: 'colt.jpg', tag: '' },
				{ brand: 'crkt', img: 'crkt.jpg', tag: '' },
				{ brand: 'cz', img: 'cz.jpg', tag: '' },
				{ brand: 'eotech', img: 'eotech.png', tag: '' },
				{ brand: 'fn-herstal', img: 'fn-herstal.jpg', tag: '' },
				{ brand: 'franchi-feels-right', img: 'franchi-feels-right.png', tag: '' },
				{ brand: 'geissele-automatics', img: 'geissele-automatics.jpg', tag: '' },
				{ brand: 'gerber', img: 'gerber.png', tag: '' },
				{ brand: 'glock', img: 'glock.jpg', tag: '' },
				{ brand: 'henry', img: 'henry.jpg', tag: '' },
				{ brand: 'hi-point', img: 'hi-point.png', tag: 'hipoint' },
				{ brand: 'hogue', img: 'hogue.png', tag: '' },
				{ brand: 'holosun', img: 'holosun.png', tag: '' },
				{ brand: 'iwi', img: 'iwi.png', tag: '' },
				{ brand: 'kel-tec', img: 'kel-tec.png', tag: '' },
				{ brand: 'kershaw', img: 'kershaw.jpg', tag: 'kershaw knives' },
				{ brand: 'kimber', img: 'kimber.png', tag: '' },
				{ brand: 'leupold', img: 'leupold.png', tag: '' },
				{ brand: 'magpul', img: 'magpul.png', tag: '' },
				{ brand: 'midwest-industries', img: 'midwest-industries.jpg', tag: '' },
				{ brand: 'mossberg', img: 'mossberg.jpg', tag: '' },
				{ brand: 'nightforce-optics', img: 'nightforce-optics.png', tag: '' },
				{ brand: 'olight', img: 'olight.jpg', tag: '' },
				{ brand: 'psa', img: 'palmetto-state-armory.png', tag: 'palmetto state armory' },
				{ brand: 'remington', img: 'remington.jpg', tag: '' },
				{ brand: 'ruger', img: 'ruger.jpg', tag: '' },
				{ brand: 'savage-arms', img: 'savage-arms.jpg', tag: '' },
				{ brand: 'schmidt-bender', img: 'schmidt-bender.png', tag: '' },
				{ brand: 'sig', img: 'sig.jpg', tag: 'sig sauer' },
				{ brand: 'smith-and-wesson', img: 'smith-and-wesson.jpg', tag: 'smith & wesson' },
				{ brand: 'sw', img: 'smith-and-wesson.jpg', tag: 'smith & wesson' },
				{ brand: 'springfield-armory', img: 'springfield-armory.jpg', tag: '' },
				{ brand: 'spyderco', img: 'spyderco.jpg', tag: '' },
				{ brand: 'stoeger', img: 'stoeger.png', tag: '' },
				{ brand: 'streamlight', img: 'streamlight.png', tag: '' },
				{ brand: 'surefire', img: 'surefire.png', tag: '' },
				{ brand: 'taurus', img: 'taurus.jpg', tag: '' },
				{ brand: 'trijicon', img: 'trijicon.png', tag: 'trijicon' },
				{ brand: 'vortex', img: 'vortex-optics.png', tag: '' },
				{ brand: 'walther', img: 'walther.jpg', tag: '' },
				{ brand: 'zero-tolerance-knives', img: 'zero-tolerance-knives.png' }
			]
		}
	},
	computed: {
		brands() {
			try {
				return this.availableBrands.filter(brand => this.include.indexOf(brand.brand) !== -1);
			}catch(e) {
				return [];
			}
		}
	},
	methods: {}
};
</script>

<style lang="scss">
.brand-logo-grid {
	position: relative;
	text-align: center;

	.list {
		position: relative;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		>div {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 200px;
			flex-basis: 200px;
			flex-shrink: 0;
			margin: 15px 30px;
		}
	}

	img {
		width: 100%;
		max-width: 100%;
		height: auto;
	}
}
</style>